module.exports = __webpack_public_path__ + "static/videos/woodcut_cut002.6e6ba32.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/woodcut/woodcut_cut002.mp4
// module id = 476
// module chunks = 1